import SabersPromo from './SabersPromo'

export default SabersPromo
